import { render, staticRenderFns } from "./api-tab.vue?vue&type=template&id=207e793a"
import script from "./api-tab.vue?vue&type=script&lang=js"
export * from "./api-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports